// ##### 24-05-21 Komarov
import moment from 'moment';
// ##### Komarov 2025-07-12
import React, { createContext, useEffect, useMemo, useState } from 'react';
// ##### 25-05-10 Komarov
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../hooks/useLocalizedText.js';

// ##### 25-05-21 Komarov
import HotelsAutocomplete from '../HotelsAutocompleteBlock/HotelsAutocomplete/HotelsAutocomplete';
import ToursAutocomplete from '../ToursAutocompleteBlock/ToursAutocomplete';
// ##### 25-01-22 Komarov
import { getTogglerType } from '../../../../Redux/actions';

// ##### 23-09-14 Komarov
// import './Search.css';
// import './SwitcherFront.css';
// import 'antd/dist/antd.css';
// ##### 25-05-21 Komarov
import SwitcherTag from './SwitcherTag';

// ##### 24-05-21 Komarov
export const LargeScreenSearchContext = createContext();

// ##### Komarov 2025-07-21
const LargeScreenSearch = ({ formClass, datepickerClass, switcherRef }) => {
  // ##### Komarov 2025-07-14
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // ##### Komarov 2025-08-05
  const hotels = useLocalizedText('Hotels');
  const tours = useLocalizedText('Tours');

  const dispatch = useDispatch();

  const [align, setAlign] = useState('HOTELS');

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(getTogglerType(align));
    // ##### 23-04-12 Komarov
  }, [align, dispatch]);

  const toggler = me => _ => {
    setAlign(me);
  };

  const onSubmit = e => {
    e.preventDefault();
  };

  // ##### 25-01-22 Komarov
  const largeScreenSearchContextValue = useMemo(
    () => ({
      toggler,
      align,
      hotels,
      tours,
    }),
    [align, hotels, tours]
  ); // value is cached by useMemo

  // ##### 24-05-21 Komarov
  return (
    <LargeScreenSearchContext.Provider value={largeScreenSearchContextValue}>
      <div
        data-component="LargeScreenSearch"
        // ##### 23-11-10 Komarov
        className="largeScreenSearch"
      >
        <SwitcherTag />

        <>
          {align === 'TOURS' ? (
            <>
              <ToursAutocomplete
                formClass={formClass}
                onSubmit={onSubmit}
                datepickerClass={datepickerClass}
              />
            </>
          ) : (
            <>
              <HotelsAutocomplete
                formClass={formClass}
                datepickerClass={datepickerClass}
                switcherRef={switcherRef}
              />
            </>
          )}
        </>
      </div>
    </LargeScreenSearchContext.Provider>
  );
};

export default LargeScreenSearch;
